import { useEffect } from 'react';

const KbServiceDocsRedirect = () => {
  useEffect(() => {
    const apiUrl = import.meta.env.VITE_API_URL;
    if (apiUrl) {
      const backendUrl = new URL(apiUrl).origin;
      window.location.href = `${backendUrl}/docs/kb-service`;
    } else {
      console.error('VITE_API_URL is not defined');
    }
  }, []);

  return <div>Redirecting to KB Service Docs...</div>;
};

export default KbServiceDocsRedirect;
